// extracted by mini-css-extract-plugin
export default {"rightSidebarWrapper":"rightSidebarWrapper__HeenmwHDoF23","chatPaneGroup":"chatPaneGroup__YsglV3dyqMpW"};